export default __webpack_public_path__ + "static/media/django.791cd2cd.png";